import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  console.log('✅ useIsMobile hook called correctly');
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

// Legacy export to catch any stale imports
export const useMobile = () => {
  console.error('❌ DEPRECATED: useMobile is deprecated, use useIsMobile instead');
  return useIsMobile();
};
